import React, { useState } from 'react';
import { X } from 'lucide-react';
import StripeSubscriptionPaymentForm from '../vendor/StripeSubscriptionPaymentForm';

const PaymentModal = ({
  isOpen,
  onClose,
  selectedPlan,
  billingInterval = 'monthly',
  checkoutAmount,
  onPaymentSuccess,
  onPaymentError,
}) => {
  const [cardholderName, setCardholderName] = useState('');

  if (!isOpen || !selectedPlan) return null;

  const handlePaymentSuccess = (data) => {
    if (onPaymentSuccess) {
      onPaymentSuccess(data);
    }
  };

  const handlePaymentError = (error) => {
    if (onPaymentError) {
      onPaymentError(error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 sm:p-8 my-4 max-h-[90vh] overflow-y-auto relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-900 transition-colors z-10"
        >
          <X className="w-5 h-5" />
        </button>

        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
          Complete Your Subscription
        </h3>
        
        <div className="mb-6">
          <h4 className="font-medium text-gray-900 mb-2 text-sm sm:text-base">Selected Plan:</h4>
          <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
            <div className="flex justify-between items-center gap-2">
              <span className="font-medium text-sm sm:text-base">{selectedPlan.name}</span>
              <span className="text-lg sm:text-xl font-bold whitespace-nowrap">
                ${Number(checkoutAmount ?? selectedPlan.price ?? 0).toFixed(2)}
                <span className="text-sm font-normal text-gray-600 ml-1">
                  /{billingInterval === 'yearly' ? 'year' : 'month'}
                </span>
              </span>
            </div>
            <p className="text-xs sm:text-sm text-gray-600 mt-1">{selectedPlan.description}</p>
          </div>
        </div>

        {/* Stripe Payment Form */}
        <StripeSubscriptionPaymentForm
          key={`${selectedPlan.id}-${billingInterval}-${checkoutAmount}`}
          subscriptionId={selectedPlan.id}
          billingInterval={billingInterval}
          amount={checkoutAmount ?? selectedPlan.price}
          onSuccess={handlePaymentSuccess}
          onError={handlePaymentError}
          metadata={{
            cardholderName: cardholderName,
            onCardholderNameChange: setCardholderName
          }}
        />
      </div>
    </div>
  );
};

export default PaymentModal;
